
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function SolutionsSection() {
  const { t } = useTranslation();

  const solutions = [
    {
      icon: 'ri-home-smile-line',
      title: t('solutions.residential.title'),
      description: t('solutions.residential.description'),
      image: 'https://public.readdy.ai/ai/img_res/dee172b05bcb121488a884b800773a27.jpg',
      features: ['Smart Home Automation', 'Premium Interior Design', 'Energy Management', 'Security Systems']
    },
    {
      icon: 'ri-building-2-line',
      title: t('solutions.commercial.title'),
      description: t('solutions.commercial.description'),
      image: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20office%20building%20interior%20in%20Saudi%20Arabia%20with%20professional%20electrical%20installations%2C%20contemporary%20lighting%20design%2C%20and%20premium%20fitout%20work%20with%20clean%20minimalist%20aesthetic&width=500&height=400&seq=solution2&orientation=landscape',
      features: ['Office Spaces', 'Retail Centers', 'Restaurants', 'Hotels']
    },
    {
      icon: 'ri-factory-line',
      title: t('solutions.industrial.title'),
      description: t('solutions.industrial.description'),
      image: 'https://readdy.ai/api/search-image?query=Industrial%20facility%20with%20robust%20electrical%20and%20mechanical%20systems%20installation%20in%20a%20Saudi%20Arabian%20manufacturing%20plant%20with%20heavy%20duty%20equipment%20and%20professional%20cable%20management&width=500&height=400&seq=solution3&orientation=landscape',
      features: ['Manufacturing Plants', 'Warehouses', 'Power Distribution', 'Control Systems']
    },
    {
      icon: 'ri-hospital-line',
      title: t('solutions.healthcare.title'),
      description: t('solutions.healthcare.description'),
      image: 'https://readdy.ai/api/search-image?query=Modern%20healthcare%20facility%20interior%20in%20Saudi%20Arabia%20with%20specialized%20medical%20electrical%20systems%2C%20life%20safety%20equipment%2C%20and%20clean%20hospital%20grade%20finishes%20with%20professional%20installation&width=500&height=400&seq=solution4&orientation=landscape',
      features: ['Hospitals', 'Medical Centers', 'Clinics', 'Emergency Systems']
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="solutions" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('solutions.title')} <span className="text-[#FE5000]">{t('solutions.titleHighlight')}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('solutions.subtitle')}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {solutions.map((solution, index) => (
            <div key={index} className="group">
              <div className="bg-gray-50 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300">
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={solution.image} 
                    alt={solution.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <div className="absolute top-6 left-6">
                    <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center">
                      <i className={`${solution.icon} text-white text-2xl`}></i>
                    </div>
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{solution.title}</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">{solution.description}</p>
                  <div className="grid grid-cols-2 gap-3 mb-6">
                    {solution.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center">
                        <i className="ri-check-line text-[#FE5000] mr-2"></i>
                        <span className="text-sm text-gray-600">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <Button 
                    variant="outline" 
                    className="w-full border-[#005776] text-[#005776] hover:bg-[#005776] hover:text-white"
                    onClick={scrollToContact}
                  >
                    <i className="ri-arrow-right-line mr-2"></i>
                    {t('learnMore')}
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
